import { createContext, useContext } from 'react';

type PopupEngineContextInterface = {
  availableActions?: Record<string, () => void>;
};

export const PopupEngineContext = createContext<PopupEngineContextInterface>({
  availableActions: {},
});

type PopupEngineProviderProps = {
  children: React.ReactNode;
} & PopupEngineContextInterface;

export const PopupEngineProvider = ({ availableActions, children }: PopupEngineProviderProps) => {
  return <PopupEngineContext.Provider value={{ availableActions }}>{children}</PopupEngineContext.Provider>;
};

export const usePopupEngineContext = () => {
  return useContext(PopupEngineContext);
};
